import { throwIfAborted } from '../abort.js';
/** Recovery has no quote, frame-payment or attempt-creation capability. */
export async function readFundingActionRecovery(client, provider, operationId, signal) {
    const operation = (await client.getOperation(operationId, signal)).data;
    throwIfAborted(signal);
    if (operation.id !== operationId)
        throw new Error('onramp_operation_mismatch');
    if (operation.status !== 'action_required')
        return { state: 'complete', operation };
    const connection = await provider.getConnection({ skipKyc: true });
    throwIfAborted(signal);
    if (!connection.ok)
        throw new Error('onramp_action_recovery_unavailable');
    const value = connection.value;
    if (value.status === 'connectionRequired')
        return { state: 'connect', mismatch: value.mismatch === true };
    if (value.status === 'termsAcceptanceRequired')
        return { state: 'terms' };
    if (value.status !== 'active')
        throw new Error('onramp_action_recovery_unavailable');
    const customer = await provider.getCustomer(value.customer.id);
    throwIfAborted(signal);
    if (!customer.ok)
        throw new Error('onramp_action_recovery_unavailable');
    if (customer.value.data.id !== value.customer.id)
        throw new Error('onramp_customer_mismatch');
    const kyc = customer.value.data.kyc;
    if (kyc.status !== 'active' || kyc.challenge)
        return {
            state: 'verification',
            verification: {
                customerId: value.customer.id,
                status: kyc.status,
                requirements: kyc.requirements,
                challenge: kyc.challenge ?? null,
            },
        };
    const credentials = provider.getCredentials();
    if (!credentials.ok)
        throw new Error('onramp_action_recovery_unavailable');
    const confirmed = await client.verifyRequiredAction(operationId, value.customer.id, credentials.value.accessToken, signal);
    throwIfAborted(signal);
    if (confirmed.id !== operationId)
        throw new Error('onramp_operation_mismatch');
    if (confirmed.status === 'action_required')
        throw new Error('onramp_action_recovery_unavailable');
    return { state: 'complete', operation: confirmed };
}
